import * as React from 'react';
import PropTypes from 'prop-types';
// import styled from 'styled-components';
// import { useDispatch } from 'react-redux';
// import LeadGenForm from '@cont/LeadGen/getStarted/Class';
// import postParentLead from '@actions/cbseClass';
// import SuccessFul from '@cont/LeadGen/getStarted/SuccessFul';
// import getLeadGen from '@cms/api';
// import LeadGen from '@cont/LeadGen/getStarted/LeadGen';
// import { breakpoints } from '@styles/index';
import Analyse from './Analyse';
import HeroBlock from './HeroBlock';
import Practice from './Practice';
import Understand from './Understand';
import Comments from './Comments';
import Features from './Features';
import SubscriptionInfo from './SubscriptionInfo';
import Download from './Download';
// import Expert from './Expert';
// import reducer from './reducer';
// import initialState from './initialState';
// import Modal from './Modal';
// import BookFreeClass from './BookFreeClass';

// const StyledModel = styled(Modal)`
//   display: none;
//   @media (max-width: ${breakpoints.mobile}) {
//     display: block;
//   }
// `;

function K12({ apiResponse }) {
  // const expertRef = React.useRef();
  const understandRef = React.useRef();
  // const [state, dispatch] = React.useReducer(reducer, initialState);
  // const [leadgenData, setLeadgenData] = React.useState({});
  // const dispatchFn = useDispatch();
  // const handleLeadgenOpen = () => setShowLeadGen(true);
  // const handleLeadgenClose = () => setShowLeadGen(false);
  // const handleSourceLogin = (response) => {
  //   if (response.error?.error_code === 'E132') {
  //     dispatch({
  //       type: 'SET_ERRORS',
  //       payload: { email: response.error.message }
  //     });
  //     dispatch({ type: 'SET_FORM', payload: 'BOOK_FORM' });
  //     return;
  //   }
  //   if (response.error?.error_code) return;
  //   dispatchFn(
  //     postParentLead({ name: state.name, goal_uid: state.goal_uid })
  //   ).then((res) => {
  //     if (res.type === 'PARENT_LEAD_SUCCESS') {
  //       // segment.track(LEADGEN_K12_REGISTERED, data);
  //       // sendEvents(LEADGEN_K12_REGISTERED, data);
  //     }
  //     dispatch({ type: 'SET_FORM', payload: 'SUCCESSFUL' });
  //   });
  // };
  // React.useEffect(() => {
  //   const fetchLeadGen = async () => {
  //     const res = await getLeadGen('api/lead-gens/cbse-Class-6-12');
  //     setLeadgenData(res);
  //   };
  //   fetchLeadGen();
  // }, []);
  const scrollToForm = () => {
    window.open('https://unacademy.app.link/vpDyPr4XKdb', '_blank');
    // if (expertRef.current) {
    //   expertRef.current.scrollIntoView({ behavior: 'smooth' });
    // }
  };
  return (
    <>
      <HeroBlock
        // handleLeadgenOpen={handleLeadgenOpen}
        scrollToForm={scrollToForm}
        understandRef={understandRef}
        data={apiResponse.hero}
      />
      <Understand
        // handleLeadgenOpen={handleLeadgenOpen}
        scrollToForm={scrollToForm}
        understandRef={understandRef}
        data={apiResponse.understand}
        benifitsTitle={apiResponse.benifitsTitle}
      />
      <Practice
        scrollToForm={scrollToForm}
        data={apiResponse.practice}
        benifitsTitle={apiResponse.benifitsTitle}
      />
      <Analyse
        data={apiResponse.analyse}
        scrollToForm={scrollToForm}
        benifitsTitle={apiResponse.benifitsTitle}
      />
      {apiResponse.parents.show && <Comments data={apiResponse.parents} />}
      <Features data={apiResponse.features}>
        <SubscriptionInfo
          data={apiResponse.features}
          // scrollToForm={scrollToForm}
          classes={apiResponse.explore}
        />
      </Features>
      {apiResponse.students.show && <Comments data={apiResponse.students} />}
      <Download data={apiResponse.download} />
      {/* <Expert expertRef={expertRef} data={apiResponse.expert}>
        {state.form === 'SUCCESSFUL' ? (
          <SuccessFul type="k12" success={apiResponse.leadGen.success} />
        ) : (
          <LeadGenForm
            handleSourceLogin={handleSourceLogin}
            state={state}
            dispatch={dispatch}
            heroForm={apiResponse.leadGen.heroForm}
          />
        )}
      </Expert> */}
      {/* <StyledModel open={showLeadgen} handleClose={handleLeadgenClose}>
        <BookFreeClass handleLeadgenClose={handleLeadgenClose}>
          <LeadGen apiResponse={leadgenData} onlyForm />
        </BookFreeClass>
      </StyledModel> */}
    </>
  );
}

K12.propTypes = {
  // showLeadgen: PropTypes.bool.isRequired,
  // setShowLeadGen: PropTypes.func.isRequired,
  apiResponse: PropTypes.objectOf(PropTypes.any).isRequired
};

export default K12;
